import React from "react";

export default function About() {
  return (
    <div className="page-enter about-page">
      <section className="about-hero">
        <p className="about-eyebrow">Our Journey</p>

        <h1 className="about-title">About Anvith Dazzle</h1>

        <p className="about-subtitle">
          Premium Stainless Steel Jewellery crafted for style, confidence and
          everyday elegance.
        </p>
      </section>

      <section className="about-story-section">
        <div className="about-story-grid">
          <div>
            <h2 className="about-section-title">
              A Growing Jewellery Brand Built on Trust
            </h2>

            <p className="about-copy">
              Established in 2025, Anvith Dazzle was created with a vision to
              provide stylish, durable and affordable stainless steel jewellery
              for modern customers.
            </p>

            <p className="about-copy">
              Our collection includes rings, chains, bracelets, bangles, watches
              and fashion accessories carefully selected to combine quality
              craftsmanship with contemporary trends.
            </p>

            <p className="about-copy">
              We believe jewellery is more than an accessory — it is a
              reflection of individuality, confidence and personal style.
            </p>
          </div>

          <div className="about-image-wrap">
            <img
              src="/images/about-jewellery.jpg"
              alt="About Anvith Dazzle"
              className="about-image"
            />
          </div>
        </div>
      </section>

      <section className="about-stats-section">
        <div className="about-stats-grid">
          {[
            ["2025", "Established"],
            ["6+", "Cities Reached"],
            ["100+", "Exhibition Customers"],
            ["New", "Collections Added Regularly"],
          ].map(([value, label]) => (
            <div className="about-stat-card" key={label}>
              <div className="about-stat-value">{value}</div>
              <div className="about-stat-label">{label}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="about-cities-section">
        <h2 className="about-section-title center">Growing Across Tamil Nadu</h2>

        <div className="about-city-list">
          {[
            "Tirunelveli",
            "Thoothukudi",
            "Tiruchirappalli",
            "Karur",
            "Nagercoil",
          ].map((city) => (
            <span className="about-city-pill" key={city}>
              {city}
            </span>
          ))}
        </div>
      </section>

      <section className="about-promise-section">
        <h2>Our Promise</h2>

        <p>
          Premium Stainless Steel Jewellery • Trendy Designs • Affordable Pricing
          • Excellent Customer Service • Continuous Introduction of New
          Collections
        </p>
      </section>

      <style>{`
        .about-hero {
          background: linear-gradient(135deg,#F7F2EB 0%,#E8DDD0 100%);
          padding: 110px 24px 84px;
          text-align: center;
        }

        .about-eyebrow {
          font-size: 12px;
          letter-spacing: 5px;
          text-transform: uppercase;
          color: var(--champagne);
          margin-bottom: 16px;
        }

        .about-title {
          font-family: 'Cormorant Garamond', serif;
          font-size: clamp(42px,7vw,72px);
          font-weight: 300;
          color: var(--text-dark);
          margin-bottom: 20px;
          line-height: 1.05;
        }

        .about-subtitle {
          max-width: 700px;
          margin: 0 auto;
          font-size: 18px;
          line-height: 1.8;
          color: var(--text-mid);
        }

        .about-story-section {
          max-width: 1100px;
          margin: 0 auto;
          padding: 80px 24px;
        }

        .about-story-grid {
          display: grid;
          grid-template-columns: 1.1fr 1fr;
          gap: 60px;
          align-items: center;
        }

        .about-section-title {
          font-family: 'Cormorant Garamond', serif;
          font-size: 42px;
          font-weight: 300;
          margin-bottom: 24px;
          color: var(--text-dark);
          line-height: 1.12;
        }

        .about-section-title.center {
          text-align: center;
          margin-bottom: 40px;
        }

        .about-copy {
          font-size: 16px;
          line-height: 1.9;
          color: var(--text-mid);
          margin-bottom: 20px;
        }

        .about-image-wrap {
          border-radius: 22px;
          overflow: hidden;
          box-shadow: 0 25px 60px rgba(0,0,0,0.12);
          background: var(--cream);
        }

        .about-image {
          width: 100%;
          height: 460px;
          object-fit: cover;
        }

        .about-stats-section {
          background: #fff;
          padding: 60px 24px;
        }

        .about-stats-grid {
          max-width: 1100px;
          margin: 0 auto;
          display: grid;
          grid-template-columns: repeat(4,1fr);
          gap: 24px;
        }

        .about-stat-card {
          background: var(--cream);
          padding: 35px 22px;
          text-align: center;
          border-radius: 14px;
          border: 1px solid rgba(201,169,110,0.18);
        }

        .about-stat-value {
          font-size: 42px;
          color: var(--maroon);
          font-family: 'Cormorant Garamond', serif;
        }

        .about-stat-label {
          margin-top: 8px;
          font-size: 12px;
          letter-spacing: 2px;
          text-transform: uppercase;
          color: var(--text-light);
          line-height: 1.5;
        }

        .about-cities-section {
          max-width: 1100px;
          margin: 0 auto;
          padding: 80px 24px;
        }

        .about-city-list {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          gap: 14px;
        }

        .about-city-pill {
          padding: 12px 22px;
          background: var(--cream);
          border-radius: 50px;
          color: var(--text-dark);
          font-weight: 500;
          border: 1px solid var(--border);
        }

        .about-promise-section {
          background: var(--maroon);
          color: white;
          text-align: center;
          padding: 90px 24px;
        }

        .about-promise-section h2 {
          font-family: 'Cormorant Garamond', serif;
          font-size: 50px;
          font-weight: 300;
          margin-bottom: 20px;
          color: #C9A96E;
        }

        .about-promise-section p {
          max-width: 800px;
          margin: 0 auto;
          line-height: 2;
          font-size: 17px;
          opacity: 0.9;
        }

        @media(max-width: 768px) {
          .about-hero {
            padding: 76px 18px 54px;
          }

          .about-eyebrow {
            font-size: 10px;
            letter-spacing: 3px;
          }

          .about-title {
            font-size: 42px;
          }

          .about-subtitle {
            font-size: 15px;
            line-height: 1.65;
          }

          .about-story-section {
            padding: 54px 18px;
          }

          .about-story-grid {
            grid-template-columns: 1fr;
            gap: 32px;
          }

          .about-section-title {
            font-size: 32px;
            margin-bottom: 18px;
          }

          .about-copy {
            font-size: 14px;
            line-height: 1.8;
          }

          .about-image {
            height: 320px;
          }

          .about-stats-section {
            padding: 42px 18px;
          }

          .about-stats-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 14px;
          }

          .about-stat-card {
            padding: 26px 12px;
          }

          .about-stat-value {
            font-size: 34px;
          }

          .about-stat-label {
            font-size: 10px;
            letter-spacing: 1.3px;
          }

          .about-cities-section {
            padding: 54px 18px;
          }

          .about-city-list {
            justify-content: flex-start;
            gap: 10px;
          }

          .about-city-pill {
            padding: 10px 16px;
            font-size: 13px;
          }

          .about-promise-section {
            padding: 64px 18px;
          }

          .about-promise-section h2 {
            font-size: 38px;
          }

          .about-promise-section p {
            font-size: 14px;
            line-height: 1.85;
          }
        }

        @media(max-width: 420px) {
          .about-stats-grid {
            grid-template-columns: 1fr;
          }

          .about-image {
            height: 280px;
          }
        }
      `}</style>
    </div>
  );
}